import { useDmCompliance } from '../../../hooks/useDmCompliance';
import { RingGauge } from './RingGauge';
import { summarizeScanCompliance } from './scanCompliance';

const RING_SIZE = 36;
const STROKE_WIDTH = 4;
const STRIP_CLASS =
    'flex-shrink-0 flex items-center gap-3 bg-white rounded-xl border border-gray-200 px-4 py-2';

function StripSkeleton() {
    return (
        <div className={STRIP_CLASS} aria-hidden="true">
            <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse" />
            <div className="h-3 w-32 bg-gray-200 rounded animate-pulse" />
        </div>
    );
}

interface ScanComplianceStripProps {
    patientId: string;
    dmId: number | null | undefined;
}

// The overview's scan compliance ring alone, shrunk to a strip; nothing to show without DM scans.
export function ScanComplianceStrip({ patientId, dmId }: ScanComplianceStripProps) {
    const { data, isLoading } = useDmCompliance(patientId, dmId);
    if (dmId == null) return null;
    if (isLoading) return <StripSkeleton />;
    if (!data) return null;
    const summary = summarizeScanCompliance(data.lateCount, data.onTimeCount);
    if (summary.onTimePct === null) return null;
    return (
        <div className={STRIP_CLASS}>
            <RingGauge
                pct={summary.onTimePct}
                color={summary.color}
                size={RING_SIZE}
                strokeWidth={STROKE_WIDTH}
                valueClassName="text-[10px] font-semibold"
            />
            <div className="flex flex-col min-w-0">
                <span className="text-xs font-semibold text-gray-700">Scan compliance</span>
                <span className="text-xs text-gray-500 truncate">
                    <span className="font-medium" style={{ color: summary.color }}>
                        {summary.label}
                    </span>
                    {` · ${summary.sublabel}`}
                </span>
            </div>
        </div>
    );
}
